"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationType = void 0;
var AssignationType;
(function (AssignationType) {
    AssignationType[AssignationType["Upcoming"] = 0] = "Upcoming";
    AssignationType[AssignationType["Completed"] = 1] = "Completed";
    AssignationType[AssignationType["Unfulfilled"] = 2] = "Unfulfilled";
})(AssignationType || (exports.AssignationType = AssignationType = {}));
//# sourceMappingURL=AssignationType.js.map